import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import VanillaTilt from "vanilla-tilt";

const TiltProvider = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const tiltCards = document.querySelectorAll("#tilt");
    //  eslint-disable-next-line
    // @ts-ignore
    VanillaTilt.init(tiltCards, {
      reverse: false,
      max: 15,
      speed: 500,
      scale: 1,
      glare: true,
      reset: true,
      perspective: 1000,
      transition: true,
      "max-glare": 0.09,
      "glare-prerender": false,
    });
  }, [pathname]);

  return <div className="tilt_box"></div>;
};

export default TiltProvider;
